import React from 'react';
import { StyleSheet, View } from 'react-native';

import SpeechContainer from './speech-container/speech-container';
import type { DialogInterface } from '../dialog-activity';

interface DialogContainerProps {
  dialog: DialogInterface[];
}

export default function DialogContainer({ dialog }: DialogContainerProps) {
  return (
    <View style={styles.container}>
      {dialog.map((speech, index) => (
        <SpeechContainer
          key={speech.line}
          dialog={speech}
          isRightSide={index % 2 !== 0}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
  },
});
